"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeographicalListItem = void 0;
const i18n_1 = require("@geome/react-next/lib/hooks/i18n");
const react_1 = __importDefault(require("react"));
const GeographicalListItem = ({ location }) => {
    const { translate } = (0, i18n_1.useI18n)();
    const { name, count } = location;
    return (react_1.default.createElement("li", { className: "geographical-list-item" },
        react_1.default.createElement("a", { className: "geographical-list-item__link", href: location.link }, translate(`sections.locations_list.geographical_item`, { name, count }))));
};
exports.GeographicalListItem = GeographicalListItem;
